import { plural } from '@/utils/plural';

import { RewardedAdPlayback } from './RewardedAdPlayback';
import { useRewardedAd } from './useRewardedAd';

const GENERATIONS: [string, string, string] = ['генерация', 'генерации', 'генераций'];

/**
 * «Смотреть рекламу» — единственный способ получить кредит бесплатно
 * прямо сейчас.
 *
 * Размер награды и доступность приходят с сервера: их нельзя зашивать
 * в кнопку, иначе после смены настройки интерфейс будет обещать одно,
 * а начисляться будет другое.
 */
export function RewardedAdButton() {
  const { availability, phase, playing, error, completion, watch, finish, cancel } =
    useRewardedAd();

  if (availability.isPending || availability.isError) {
    // Молчим: реклама — приятная возможность, а не часть основного пути,
    // и сообщать о её недоступности отдельной ошибкой незачем.
    return null;
  }

  const { available, reward } = availability.data;

  return (
    <div className="flex flex-col gap-2">
      {available ? (
        <button
          type="button"
          onClick={watch}
          disabled={phase !== 'idle'}
          className="btn btn-secondary px-4 py-3 text-sm"
        >
          🎬 Смотреть рекламу → +{reward} {plural(reward, GENERATIONS)}
        </button>
      ) : (
        <p className="text-sm text-text-2">
          На сегодня награды за рекламу закончились. Возвращайтесь завтра.
        </p>
      )}

      {error && <p className="text-sm text-danger">{error}</p>}

      {completion &&
        (completion.granted ? (
          <p className="text-sm text-accent">
            +{completion.reward} {plural(completion.reward, GENERATIONS)}. Осталось{' '}
            {completion.creditsLeft}.
          </p>
        ) : (
          <p className="text-sm text-text-2">
            Награда за этот показ уже начислена. Осталось {completion.creditsLeft}.
          </p>
        ))}

      {playing && (
        <RewardedAdPlayback
          reward={playing.reward}
          realAd={playing.realAd}
          finishing={phase === 'finishing'}
          onFinish={finish}
          onCancel={cancel}
        />
      )}
    </div>
  );
}
